// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"94":"main-style","399":"vendors-self"}[chunkId] + "." + {"94":"1ec79ba7","399":"53a67309"}[chunkId] + ".css";
};